<template>
  <v-card title="报销统计">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="24">
            <div style="text-align: left">
              <v-form-item>
                <vxe-input
                  size="mini"
                  v-model="bxyf"
                  placeholder="报销月份"
                  type="month"
                  valueFormat="yyyyMM"
                ></vxe-input>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>
              <v-form-item>
                <v-button type="warning" icon="export" @click="exportExcel()"
                  ><span>导出</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-table
      size="mini"
      border
      height="408"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      :expand-config="{
        accordion: true,
        lazy: true,
        loadMethod: loadContentMethod,
      }"
    >
      <vxe-table-column
        type="seq"
        width="60"
        title="序号"
        header-align="center"
        align="center"
      ></vxe-table-column>
      <vxe-table-column
        type="expand"
        width="80"
        header-align="center"
        align="center"
      >
        <template v-slot:content="{ row }">
          <vxe-grid
            class="mytable-style"
            :columns="row.childCols"
            :data="row.childData"
          >
            <template v-slot:cz="{ row }">
              <span>
                <a class="link" @click="mx(row)"
                  ><v-icon type="search"></v-icon
                ></a>
              </span>
            </template>
          </vxe-grid>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="khbh"
        title="客户编号"
        header-align="center"
        align="center"
      ></vxe-table-column>
      <vxe-table-column
        field="khmc"
        title="客户名称"
        header-align="center"
        align="center"
      ></vxe-table-column>
      <vxe-table-column
        field="bxyf"
        title="报销月份"
        header-align="center"
        align="center"
      ></vxe-table-column>
      <vxe-table-column
        field="bxrs"
        title="报销人数"
        header-align="center"
        align="right"
      ></vxe-table-column>
      <vxe-table-column
        field="bxje"
        title="报销金额"
        header-align="center"
        align="right"
        :formatter="formatterAmount"
      >
      </vxe-table-column>
    </vxe-table>
  </v-card>
</template>
<script>
import { milliFormat } from "../../../static/js/milli_format.js";
let options = {
  id: "",
};
export default {
  data() {
    return {
      options,
      tableData: [],
      bxyf: dateFormat("YYYYmm", new Date()),
      rse_bxyf: "",
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      if (this.bxyf == "") {
        this.$message["error"]("请选择报销月份！");
        return;
      }
      this.$axios
        .get("api/system/bxtj/get-bxtj-list?bxyf=" + this.bxyf)
        .then((res) => {
          this.tableData = res.data.data;
          this.rse_bxyf = res.data.bxyf;
        });
    },
    exportExcel() {
      if (this.bxyf == "") {
        this.$message["error"]("请选择报销月份！");
        return;
      }
      let a = document.createElement("a");
      a.href = "api/system/bxtj/月度汇总?bxyf=" + this.bxyf;
      a.click();
    },
    mx(row) {
      xadmin.open("编辑", "/bx?gh=" + row.gh + "&bxyf=" + row.bxyf);
    },
    loadContentMethod({ row }) {
      return new Promise((resolve) => {
        const childCols = [
          { type: "seq", title: "序号", align: "center" },
          { field: "khmc", title: "客户名称", align: "center" },
          { field: "bxyf", title: "报销月份", align: "center" },
          { field: "gh", title: "工号", align: "center" },
          { field: "xm", title: "姓名", align: "center" },
          {
            field: "bxje",
            title: "报销金额",
            align: "right",
            headerAlign: "center",
            formatter: this.formatterAmount,
          },
          {
            field: "cz",
            title: "明细",
            align: "center",
            headerAlign: "center",
            slots: { default: "cz" },
          },
        ];
        row.childCols = childCols;
        this.$axios
          .get(
            "api/system/bxtj/get-bxtj-listb?khbh=" +
              row.khbh +
              "&bxyf=" +
              this.rse_bxyf
          )
          .then((res) => {
            row.childData = res.data.data;
            resolve();
          });
      });
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["bxrs"].includes(column.property)) {
            let sum = 0;
            data.forEach((item) => {
              sum += item.bxrs;
            });
            return sum;
          } else if (["bxje"].includes(column.property)) {
            let sum = 0;
            data.forEach((item) => {
              sum += item.bxje;
            });
            return milliFormat(sum);
          }
          return null;
        }),
      ];
    },
    formatterAmount(row) {
      return milliFormat(row.cellValue.toString());
    },
    headerCellClassName({ column, columnIndex }) {
      if (column.property === "xm") {
        return "col-blue";
      }
    },
  },
};
function dateFormat(fmt, date) {
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
}
</script>


<style>
.mytable-style .vxe-table .vxe-table--header {
  background-color: rgb(170, 168, 168);
  color: aliceblue;
}
.vxe-footer--row {
  background-color: #ffbf00;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/view/bbtj/bxtj.vue